import React from 'react';
import { Card, Col } from 'react-bootstrap';
import CountUp from 'react-countup';

const StatCard = ({
                    title,
                    value,
                    icon,
                    shadow = 'shadow-sm',
                    color = 'primary',
                    lg = 3,
                    count = false, // <- nowy props
                  }) => {
  const valueStr = value?.toString() || '';
  const isPercent = valueStr.includes('%');
  const isCurrency = valueStr.includes('zł');
  const numericValue = parseFloat(valueStr.replace('%', '').replace('zł', '').trim());

  return (
    <Col lg={lg} md={6} sm={12}  className="mb-3">
      <Card className={`p-3 ${shadow} border-0`}>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h6 className="text-muted text-uppercase mb-1">{title}</h6>
            <h3 className="fw-bold mb-0">
              {count && !isNaN(numericValue) ? (
                <CountUp
                  end={numericValue}
                  duration={1.5}
                  separator=" "
                  decimals={isPercent ? 1 : 0}
                  suffix={isPercent ? '%' : isCurrency ? ' zł' : ''}
                />
              ) : (
                value
              )}
            </h3>
          </div>
          <div className={`bg-${color} bg-opacity-10 p-2 rounded-circle`}>
            {React.cloneElement(icon, { size: 24, className: `text-${color}` })}
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default StatCard;
